import axios, { AxiosResponse } from 'axios';

import { EnvironmentConfig } from '../../model/EnvironmentConfig';

//
// Get unprotected environmental information
//
export const getEnvConfig = (): Promise<AxiosResponse<EnvironmentConfig>> => axios.get<EnvironmentConfig>('env.json');
